import styled from 'styled-components'
import { positioningProps, marginProps, paddingProps } from '../FormSteps/styles'
import { colorStyles } from '../FormFields/styles'

const Label = styled.label`
  ${positioningProps}
  ${marginProps}
  ${paddingProps}

  font-size: ${props => props.fontSize || '12px'};
  font-family: ${props => props.theme.fonts.heading};
  font-weight: ${props => props.weight || props.theme.fonts.weights.bold};
  color: ${props => colorStyles(props)};
  text-transform: ${props => props.transform};
`
Label.displayName = 'Label'

export default Label
